<script>
import ListCourseCategoriesComponent from '../../features/lists/ListCourseCategoriesComponent';
import ModalCourseCategoryView from '../modals/ModalCourseCategoryView';
import ModalImportView from '../../../shared/views/ModalImportView';


export default {
  name: 'ListCourseCategoryView',
  components: {
    'modal-course-category-view': ModalCourseCategoryView,
    'modal-import': ModalImportView,
  },
  extends: ListCourseCategoriesComponent,
};
</script>

<template>
  <div class="list-body">
    <el-row
      :gutter="20"
      class="section-ctrl"
    >
      <el-col
        :xs="24"
        :sm="14"
        :md="14"
        :lg="14"
        :xl="14"
        class="header-right"
      >
        <el-button-group class="btn-grp-drp">
          <el-button
            type="primary"
            size="small"
            class="btn-primary"
            icon="el-icon-circle-plus"
            :disabled="!onCanCreate(modulePermissions)"
            @click="onCreate"
          >
            Crear Categoria
          </el-button>
          <el-dropdown>
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i class="fa fa-ellipsis-v" /> <span class="hidden-xs-only">M&aacute;s Opciones</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light"
                    icon="el-icon-upload"
                    :disabled="!onCanCreate(modulePermissions)"
                    @click="onShowImport"
                  >
                    Importar Categorias
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light btn-primary-full"
                    :disabled="!onCanRead(modulePermissions)"
                    @click="onExportToExcel()"
                  >
                    <i
                      class="fa fa-file-excel-o"
                      aria-hidden="true"
                    /> Exportar
                    Excel
                  </el-button>
                </el-dropdown-item>
              <!--<el-dropdown-item>
                <el-button size="small" class="btn-white">
                  <i class="fa fa-file-pdf-o" aria-hidden="true"></i> Exportar PDF
                </el-button>
              </el-dropdown-item>-->
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-dropdown
            trigger="click"
            :hide-on-click="false"
            popper-class="filter-dropdown-popper"
          >
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i
                class="fa fa-filter"
                aria-hidden="true"
              /> <span class="hidden-xs-only">Filtrar Por</span> <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-select
                    v-model="parentFilter"
                    size="small"
                    filterable
                    remote
                    clearable
                    placeholder="Padre..."
                    :remote-method="onSearchCourseCategory"
                    value-key="id"
                    @change="onAllFilterChange(parentFilter.id, 'Parent')"
                    @focus="onFocusCourseCategory"
                  >
                    <el-option
                      v-for="item in parents"
                      :key="item.id"
                      :label="item.name"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-button-group>
      </el-col>
      <el-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10" class="header-left search-inputs-row">
        <el-input
          v-model="searchCode"
          size="small"
          placeholder="Buscar Codigo..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(searchCode, 'Code')"
        />
        <el-input
          v-model="searchName"
          size="small"
          placeholder="Buscar nombre..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(searchName, 'Name')"
        />
      </el-col>
    </el-row>
    <el-table
      v-loading="isListLoading"
      :data="collection"
      empty-text="No se encontraron resultados."
      element-loading-spinner="el-icon-loading"
      :element-loading-text="listLoadingMessage"
    >
      <el-table-column
        label="CODIGO"
        min-width="120"
      >
        <template #default="scope">
          <div>
            {{ scope.row.code }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="NOMBRE"
        min-width="250"
      >
        <template #default="scope">
          <div>
            {{ scope.row.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="PADRE"
        align="center"
        min-width="230"
      >
        <template #default="scope">
          <div v-if="scope.row.parent">
            <el-tag
              type="info"
              effect="plain"
            >
              {{ scope.row.parent.name }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="CREACIÓN"
        :width="140"
        align="center"
      >
        <template #default="scope">
          <el-tag
            type="info"
            effect="plain"
          >
            <i class="el-icon-date" /> {{ formatDate(scope.row.createdAt) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="ACTUALIZACIÓN"
        :width="140"
        align="center"
      >
        <template #default="scope">
          <el-tag
            v-if="onCheckUpdatedAt(scope.row.updatedAt)"
            type="info"
            effect="plain"
          >
            <i class="el-icon-date" /> {{ formatDate(scope.row.updatedAt) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="OPCIONES"
        :width="160"
        align="center"
        text-align="center"
      >
        <template #default="scope">
          <el-dropdown @command="onChangeItemOptions">
            <el-button size="small">
              <i
                class="fa fa-ellipsis-v"
                aria-hidden="true"
              />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  :command="{ command: 'edit', item: scope.row }"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i
                    class="el-icon-edit"
                    aria-hidden="true"
                  /> Mostrar
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ command: 'delete', item: scope.row }"
                  :disabled="!onCanDelete(modulePermissions)"
                >
                  <i
                    class="el-icon-delete"
                    aria-hidden="true"
                  /> Eliminar
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-model:current-page="currentPage"
      size="small"
      layout="prev, pager, next"
      :page-count="pagination.totalPages"
      @current-change="onPageChange"
    />
    <modal-course-category-view
      v-if="modalItem.isVisible"
      :form-data="item"
      :conf="modalItem"
    />
    <modal-import :conf="modalImport" />
  </div>
</template>

